module.exports = __webpack_public_path__ + "img/logo_inabio.9e338764.svg";